import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const DoctubeUserInsight = lazy(() => import("../pages/doctube-user-insight"));
const EmbeddedSmsCreate = lazy(() => import("../pages/embaded-sms-gengerator"));
const EmbeddedWhatsappCreate = lazy(() =>
  import("../pages/embaded-whatsapp-generator")
);
const EmbeddedEmailCreate = lazy(() =>
  import("../pages/embedded-email-generator")
);

export const EmbeddedToolsRouter = [
  {
    path: "embedded-tools",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "create-email",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EmbeddedEmailCreate />
          </Suspense>
        ),
      },
      {
        path: "create-sms",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EmbeddedSmsCreate />
          </Suspense>
        ),
      },
      {
        path: "create-whatsapp",
        element: (
          <Suspense fallback={<Backdrop />}>
            <EmbeddedWhatsappCreate />
          </Suspense>
        ),
      },
      {
        path: "ga-user-analytics/:link",
        element: (
          <Suspense fallback={<Backdrop />}>
            <DoctubeUserInsight />
          </Suspense>
        ),
      },
    ],
  },
];
